import smartSolveApi from './instances/smartsolve';

export const extendSessionTimeout = async (prevToken, userLastActivityDate) => {
  try {
    const response = await smartSolveApi.post('/extendsession', {
      prevToken,
      userLastActivityDate,
    });
    return response.data;
  } catch (e) {
    throw new Error(`extendsession() failed: ${e}`);
  }
};
